import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const updateAIModelPricingSchema = z.object({
  aiProviderId: z.string().min(1),
  modelId: z.string().min(1),
  inputPerMillion: z.number().nonnegative(),
  outputPerMillion: z.number().nonnegative(),
  cacheReadPerMillion: z.number().nonnegative().optional(),
  cacheWritePerMillion: z.number().nonnegative().optional(),
});

export const updateAIModelPricing = mutator({
  schema: updateAIModelPricingSchema,
  resolve: {
    aiProvider: { kind: "aiProvider", from: "aiProviderId" },
  },
  permissions: [
    {
      permission: "tenant:ai_providers_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, ctx, args }) => {
    const now = Date.now();
    const existing = await tx.run(
      zql.aiModelPricing
        .where("aiProviderId", args.aiProvider.id)
        .where("modelId", args.modelId)
        .one()
    );
    const values = {
      inputPerMillion: args.inputPerMillion,
      outputPerMillion: args.outputPerMillion,
      cacheReadPerMillion: args.cacheReadPerMillion ?? null,
      cacheWritePerMillion: args.cacheWritePerMillion ?? null,
      updatedAt: now,
    };
    if (existing) {
      await tx.mutate.aiModelPricing.update({
        aiProviderId: args.aiProvider.id,
        modelId: args.modelId,
        ...values,
      });
      return;
    }
    await tx.mutate.aiModelPricing.insert({
      aiProviderId: args.aiProvider.id,
      modelId: args.modelId,
      ...values,
      tenantId: ctx.tenantId,
    });
  },
});
